/**
 * Jubly Logo — the Jubilee dove.
 *
 * An abstract dove of peace rising toward freedom, rooted in the biblical
 * Jubilee (Leviticus 25): the year liberty was proclaimed throughout the land.
 *  - Green wing (left): growth, provision, the prosperity of a restored land
 *  - Blue wing (right): peace, trust, liberty — with a thread of gold for
 *    jubilation and the light of a new dawn
 *  - Olive branch in the beak: peace and reconciliation flowering into flourishing
 *  - Spiralling tail: the Jubilee's sacred rhythm (7×7 → the 50th year) and the
 *    root of "yovel" — to flow, to carry home
 *
 * Rendered from /jubly-logo.svg so it stays crisp at every size.
 */

export default function JublyLogo({ size = 32, className = '' }) {
  return (
    <img
      src="/jubly-logo.svg"
      width={size}
      height={size}
      className={className}
      alt="Jubly"
      style={{ objectFit: 'contain', display: 'inline-block' }}
      draggable={false}
    />
  );
}
